import React from 'react';

function TextContentInner(props) {
    // First item: about text; Second item: core services heading + text
    const about = props.content[0];
    const coreServices = props.content[1];
    return (
        <>
            <div className="text-content-inner">
                <div className="container">
                    <div className="row d-flex align-items-start">
                        <div className="col-lg-6">
                            <div className="paragraph light-1">
                                <p>{about.content}</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                                    <div className="paragraph light-1">
                                <p>{coreServices.content}</p>
                                    </div>
                                </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TextContentInner;
